<template>
  <section class="section-video section-home-slider light">
    <video autoplay loop muted :poster="require('Assets/images/bg_2.jpg')">
      <source :src="require('Assets/media/videos/video.mp4')" type="video/mp4">
    </video>
    <div class="container">
      <hr class="space"/>
      <div class="row">
        <div class="col-lg-12">
          <carousel class="slider"
                    autoplay
                    navigationNextLabel="<i class='fa fa-regular fa-angle-right'></i>"
                    navigationPrevLabel="<i class='fa fa-regular fa-angle-left'></i>"
                    :navigationEnabled="true"
                    :scrollPerPage="true" :perPageCustom="[[480, 1], [768, 1]]"
          >
            <slide>
              <h2>GERADORES FOTOVOLTAICOS</h2>
              <br>
              <h1>100% Pronta Entrega. Envio rápido para todo o Brasil.</h1>

              <a class="img-box" href="#">
                <img :src="require('Assets/images/mk-1.png')" alt="">
              </a>
            </slide>
            <slide>
              <h2>COMPONENTES</h2>
              <br>
              <h1>Solução completa. Qualidade e eficiência.<br></h1>

              <a class="img-box" href="#">
                <img :src="require('Assets/images/mk-2.png')" alt="">
              </a>
            </slide>
            <slide>
              <h2>COTAÇÕES ONLINE</h2>
              <br>
              <h1>Faça seu cadastro e se torne um parceiro Sky Solar!</h1>

              <a class="img-box" href="#">
                <img :src="require('Assets/images/mk-3.png')" alt="">
              </a>
            </slide>
          </carousel>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'Banner',
  components: {
    Carousel,
    Slide,
  },
};
</script>

<style>
.section-video {
  top: -65px;
}
.VueCarousel-dot-container {
  float: right;
  margin-top: 0 !important;
}
.VueCarousel-dot-container button {
  margin-top: 0 !important;
}
.VueCarousel-dot {
  border-radius: 15px !important;
  padding: 0 !important;
  border: solid 1px #0098da !important;
  margin: 0 5px !important;
  background: transparent !important;
}
.VueCarousel-dot--active {
  width: 28px !important;
  background: #FFF !important;
}
video {
  width: 3450px !important;
}
.section-video .VueCarousel-navigation-button{
  bottom: 0 !important;
  top: inherit !important;
}
.section-video .VueCarousel-navigation-next {
  left: 40px !important;
}
.section-home-slider h1 {
  width: 400px !important;
}

</style>
